import React from 'react';
import ServicePremimum from '../../components/ServicePremimum';
import ServicePlan from '../../components/ServicePlan';
import CoursesBanner from '../../components/CoursesBanner';
import CourseBannerAbout from '../../components/CourseBannerAbout';
import FeaturedCourses from '../../components/FeaturedCourses';
import CoursesLearningTools from '../../components/CoursesLearningTools';
import FAQSection from '../../components/FAQSection';

const Courses = () => {
  return (
    <div >
      <CoursesBanner />
    <CourseBannerAbout />
    <FeaturedCourses />
    <CoursesLearningTools />
    <FAQSection />
    </div>
  );
};

export default Courses;
